'use strict';

var Swiper = require('swiper').default;

var $allBillboards = document.querySelectorAll('.js-swiper-billboard');

[].map.call($allBillboards, _renderBillboard);

function _addLazy(slide, selector) {
  if (
    slide.querySelector(selector) &&
    !/lazyload/i.test(slide.querySelector(selector).classList.value)
  ) {
    slide.querySelector(selector).classList.add('lazyload');
  }
}

function _hasVideo(slide) {
  return slide && slide.classList.contains('swiper-slide-video');
}

function _playVideo(video) {
  video.currentTime = 0;
  video.loop = false;
  video.play();
}

function _stopVideo(video) {
  video.pause();
  video.currentTime = 0;
}

function _renderBillboard($billboard) {
  var config = {
    loop: true,
    autoplay: {
      delay: 7500
    },
    navigation: {
      nextEl: '.icon-arrow-right',
      prevEl: '.icon-arrow-left'
    },
    preloadImages: false
  };

  var billboard = new Swiper($billboard, config);

  billboard.on('slideChange', function () {
    var slider = this;
    var slide = slider.slides[slider.activeIndex];
    var prevSlide = slider.slides[slider.previousIndex];
    var currentVideo = _hasVideo(slide) && slide.querySelector('video');
    var previousVideo = _hasVideo(prevSlide) && prevSlide.querySelector('video');

    if (currentVideo) {
      _playVideo(currentVideo);

      if (slider.autoplay.running) {
        slider.autoplay.stop();
        currentVideo.addEventListener(
          'ended',
          function () {
            slider.autoplay.start();
          },
          { once: true }
        );
      }
    }

    if (previousVideo) {
      _stopVideo(previousVideo);
    }

    _addLazy(slide, 'img');
    _addLazy(slide, 'video');
  });
}
